import { render } from "./WidgetContentError.vue?vue&type=template&id=215015b7"
import script from "./WidgetContentError.vue?vue&type=script&lang=js"
export * from "./WidgetContentError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__